export default "__VITE_ASSET__1473a4e5__"